import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `RegistroAlimentacion`, method: 'GET', body: null, token: token})
}
